const dispatchErrorEvent = (detail) => {
  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent('handleErrorMessage', true, true, detail);
  window.dispatchEvent(evt);
};

const showError = (message, href) => {
  dispatchErrorEvent({ message, href });
};

export default showError;
export { showError };
